import { Badge } from "design-system/atoms/Badge"
import { Box, Code, Plug, Webhook, Wrench } from "lucide-react"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { CapabilityKind } from "schema"

export function useKindBadge() {
  const { t } = useTranslation()

  return useCallback(
    (kind: keyof typeof CapabilityKind) => {
      const kindConfig = {
        [CapabilityKind.Integration]: {
          icon: Plug,
          label: t("capabilities.list.kind.integration"),
        },
        [CapabilityKind.Webhook]: {
          icon: Webhook,
          label: t("capabilities.list.kind.webhook"),
        },
        [CapabilityKind.Instruction]: {
          icon: Wrench,
          label: t("capabilities.custom.instruction.name"),
        },
        [CapabilityKind.MCP]: {
          icon: Code,
          label: t("capabilities.list.kind.mcp"),
        },
        [CapabilityKind.Native]: {
          icon: Box,
          label: t("capabilities.list.kind.native"),
        },
      }[kind]

      if (!kindConfig) return null

      const KindIcon = kindConfig.icon

      return (
        <Badge variant="outline" className="shrink-0">
          <KindIcon className="size-3" />
          <span>{kindConfig.label}</span>
        </Badge>
      )
    },
    [t],
  )
}
